/* Scentasy desktop collection menu. The Shop text remains a normal collection link. */
(function () {
  'use strict';
  var current = new URL(window.location.href);
  document.querySelectorAll('.sc-sort-form').forEach(function (form) {
    ['preview_theme_id', 'pb'].forEach(function (key) {
      if (!current.searchParams.has(key) || form.querySelector('input[name="' + key + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = key; input.value = current.searchParams.get(key);
      form.appendChild(input);
    });
  });
  var group = document.getElementById('scShopNav');
  if (!group) return;
  var toggle = group.querySelector('.sc-scents-toggle');
  var timer;
  function setOpen(open) {
    clearTimeout(timer);
    group.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  }
  group.addEventListener('mouseenter', function () { if (window.innerWidth >= 990) setOpen(true); });
  group.addEventListener('mouseleave', function () { timer = setTimeout(function () { setOpen(false); }, 160); });
  group.addEventListener('focusin', function (e) { if (window.innerWidth >= 990 && e.target !== toggle) setOpen(true); });
  group.addEventListener('focusout', function (e) { if (!group.contains(e.relatedTarget)) setOpen(false); });
  toggle.addEventListener('click', function () { setOpen(!group.classList.contains('is-open')); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  document.addEventListener('click', function (e) { if (!group.contains(e.target)) setOpen(false); });
  window.addEventListener('resize', function () { if (window.innerWidth < 990) setOpen(false); });
})();
